import { HTMLAttributes } from 'react';
import { MarketButton } from '@market/react';
import { useTranslation } from 'react-i18next';
import { ValidationResponseAddress } from 'typescript/types/api/address_validation';
import styles from 'typescript/apps/checkout_v3/components/address_validation/address_validation.module.scss';

export const VALIDATION_FAILURE_TEST_ID = 'validation-failure';
export const USE_CUSTOM_ADDRESS_CTA_TEST_ID = 'use-custom-address-cta';

interface ValidationFailureProps extends HTMLAttributes<HTMLDivElement> {
  originalAddress: ValidationResponseAddress;
  onOriginalClick: () => void;
}

const ValidationFailure = ({
  className,
  originalAddress,
  onOriginalClick,
}: ValidationFailureProps) => {
  const { t } = useTranslation();
  const { address_line_1, address_line_2 } = originalAddress;

  return (
    <div
      data-testid={VALIDATION_FAILURE_TEST_ID}
      className={`${styles.container} ${className}`}
    >
      <h3>
        {t('checkout.delivery.validation.notFound', {
          address: address_line_1,
        })}
        {address_line_2 && `, ${address_line_2}`}
      </h3>
      <p className="paragraph-20">
        {t('checkout.delivery.validation.delayWarning')}
      </p>
      <MarketButton
        data-testid={USE_CUSTOM_ADDRESS_CTA_TEST_ID}
        className={styles.useCustomAddressCTA}
        rank="secondary"
        onClick={onOriginalClick}
      >
        {t('checkout.delivery.validation.useCustom')}
      </MarketButton>
    </div>
  );
};

export default ValidationFailure;
